module.exports = __webpack_public_path__ + "static/home-1-m-9b983ab5d32ed796a4e5ae18bc1279cc.mp4";